import React, { useEffect, createElement } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { DiarySection } from './components/DiarySection';
import { ProductReveal } from './components/ProductReveal';
import { ProductExplanation } from './components/ProductExplanation';
import { DidYouKnow } from './components/DidYouKnow';
import { ExpertQuote } from './components/ExpertQuote';
import { Testimonials } from './components/Testimonials';
import { FaqSection } from './components/FaqSection';
import { TrustBar } from './components/TrustBar';
import { CtaSection } from './components/CtaSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    const script = document.createElement('script');
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];
    w[l].push({'gtm.start':new Date().getTime(),
    event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
    j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='
    +i+dl;f.parentNode.insertBefore(j,f);})(window,document,
    'script','dataLayer','GTM-KZBZMFT');`;
    document.head.appendChild(script);
  }, []);
  return <div className="min-h-screen flex flex-col selection:bg-forestGreen/20" data-id="element-0">
      <Header data-id="element-1" />

      <main className="flex-grow" data-id="element-2">
        <HeroSection data-id="element-3" />
        <DiarySection data-id="element-4" />
        <ProductReveal data-id="element-5" />
        <ProductExplanation data-id="element-6" />
        <DidYouKnow data-id="element-7" />
        <ExpertQuote data-id="element-8" />
        <Testimonials data-id="element-9" />
        <FaqSection data-id="element-10" />
        <TrustBar data-id="element-11" />
        <CtaSection data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
    </div>;
}